import React from 'react'

export const wrapInterpolatedValues = (text: string) => {
  const parts = text.split(/(\{\{[^}]+\}\}|\b\d+\b)/g).filter(Boolean)

  return (
    <>
      {parts.map((part, index) => {
        if (/\{\{[^}]+\}\}/.test(part) || (/^\d+$/.test(part) && !part.startsWith('{'))) {
          return <strong key={index}>{part}</strong>
        }
        return part
      })}
    </>
  )
}
